import { createContext } from 'react';

import { SelectedCardContextProps } from './SelectedCardContext.type';

export const SelectedCardContext = createContext<SelectedCardContextProps | undefined>(undefined);
